import {SearchOptionsRequest} from '../SearchOptionsRequest.model';

export class UnitBankAccountTransactionsSearchOptionsRequest extends SearchOptionsRequest {
  startDate: Date = null;
  endDate: Date = null;
  typeName: string = null;
  excludeFees: boolean = null;
}
